import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { NgImageSliderComponent } from "ng-image-slider";
import { iconsLibrary } from "../../../../theme/constants";
import { EButtonType } from "../../../data-types/button.enum";
import { CoworkingService } from "../../../services/coworking.service";
import { showAlertAction } from "../../../store/actions/alert.action";
import { closeLoadingAction, showLoadingAction } from "../../../store/actions/loading.action";
import { IAppState } from "../../../store/state/app.state";
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: "cowing-coworker-card",
  templateUrl: "./cowing-coworker-card.component.html",
  styleUrls: ["./cowing-coworker-card.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class CowingCoworkerCardComponent implements OnInit {
  public essentialsServices;
  public othersServices;
  public coworkingInfo;
  public mediaObject:Array<object> = [];
  public coworkingSpaces;
  @ViewChild('nav') slider: NgImageSliderComponent;
  @ViewChild('sliderPagination') sliderPagination: ElementRef;
  public paginationHTML = [];
  public newIndex;
  public currentIndex = 0;
  @Input("coworkingId") coworkingId;
  constructor(
    private router: Router,
    private _store: Store<IAppState>,
    private translate: TranslateService,
    private platform: Platform
  ) {}
  @Input("coworking") coworking: any;
  @Input("showClose") showClose: boolean = false;
  @Output("close") close = new EventEmitter();
  @Input("showMode") showMode = false;
  @Input('isMobile') isMobile = false;
  @Input('previous') previous = '';
  public EButtonType = EButtonType;
  iconsLibrary;

  async ngOnInit() {
      Object.values(this.coworking.images ?? []).map(img => {
        this.mediaObject.push(({
          image: img,
          thumbImage: img
        }));
      });

      if (this.coworking?.video) {
        this.mediaObject.push({ video: this.coworking?.video });
      }
      //console.log(this.slider);
      //console.log("Object", this.mediaObject);
      // for(let i = 0; i < this.mediaObject.length; i++){
      //   this.paginationHTML.push('<div><span class="slider-bullet" data-index="'+i+'" ></span></div>');
      //   console.log(this.paginationHTML);
       // console.log("botones generados...", this.paginationHTML);
      //}
      //console.log(this.slider);
      //this.sliderPagination.nativeElement.innerHTML = this.paginationHTML.join("");
  }
  // changeSlider(e){
  //   console.log(this.slider);
  //   console.log(this.mediaObject.length)
  //   var target = e.target;
  //   if(target.classList.contains("slider-bullet")){
  //     this.newIndex = Number(target.getAttribute("data-index"));
  //     console.log("nuevo index selected: ", this.newIndex);
  //     if(this.newIndex < this.slider.imageObj){
  //       this.slider.next;
  //     }else{
  //       this.slider.prev;
  //     }
  //     console.log("nuevo index: ", this.newIndex);
  //     this.slider.prev;
  //   }
  // }

  public redirectToDetails() {
    this.router.navigate(["coworking-detail"], {
      queryParams: { coworkingId: this.coworking?.id, previous: this.previous },
    });
  }
  get defaultImage() {
    if (this.coworking?.images["1"] !== null) {
      return this.coworking?.images["1"];
    }
    return `${iconsLibrary.landingImage}`;
  }

  get getCloseIcon() {
    return `${iconsLibrary.closeSvg}`;
  }

  get getLocationOffIcon() {
    return `${iconsLibrary.locationOff}`;
  }

  public closeCard() {
    this.close.emit();
  }

  public isOpened() {
    if (this.coworking) {
      let dayOfWeek = new Date().getDay();
      let todayInMs = new Date().getTime();
      let openingDate = new Date();
      let closingDate = new Date();
      let startHours = null;
      let endHours = null;

      if (dayOfWeek === 0) {
        startHours = this.coworking?.hours[0]?.start.split(":");
        openingDate.setHours(startHours[0], startHours[1]);
        if (this.coworking?.hours[0].end === "00:00") {
          closingDate.setHours(23, 59);
        } else {
          endHours = this.coworking?.hours[0]?.end.split(":");
          closingDate.setHours(endHours[0], endHours[1]);
        }
      } else if (this.coworking?.hours[dayOfWeek - 1]) {
        startHours = this.coworking?.hours[dayOfWeek - 1]?.start.split(":");
        openingDate.setHours(startHours[0], startHours[1]);
        if (this.coworking?.hours[dayOfWeek - 1]?.end === "00:00") {
          closingDate.setHours(23, 59);
        } else {
          endHours = this.coworking?.hours[dayOfWeek - 1]?.end.split(":");
          closingDate.setHours(endHours[0], endHours[1]);
        }
      }
      return (
        openingDate.getTime() < todayInMs && todayInMs < closingDate.getTime()
      );
    }
  }

  public goBooking() {
    this.router.navigate(["booking"], {
      queryParams: { coworkingId: this.coworking?.id },
    });
  }

  public showModal() {
    if (this.isMobile) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: this.translate.instant('general.no-location'),
            title: this.translate.instant('general.caution'),
            type: 'errorLocation',
            optionOkText: this.translate.instant('general.active-location'),
            optionCancelText: this.translate.instant('general.deactivate-location'),
          },
        })
      );
    }
  }
}
